import Vue from 'vue';

const state = {
  amazonUrl: null,
  bookshelf: null,
  tipData: {
    isLoading: false,
    total: 0,
  },
  voteData: {},
};

const getters = {
  'get-amazon-url': (state) => state.amazonUrl,
  'get-bookshelf': (state) => state.bookshelf,
  'get-tip-data': (state) => state.tipData,
  'get-vote-data': (state) => state.voteData,
};

const actions = {
  addTipValue({ commit }, tipValue) {
    commit('addTipValue', tipValue);
  },

  saveAmazonUrl({ commit }, voteData) {
    commit('saveAmazonUrl', voteData);
  },

  saveVoteData({ commit }, voteData) {
    commit('saveVoteData', voteData);
  },

  setBookshelf({ commit }, bookshelf) {
    commit('saveBookshelf', bookshelf);
  },

  setIsLoadingTipData({ commit }) {
    commit('saveIsLoadingTipData');
  },

  setTipValue({ commit }, tipValue) {
    commit('saveTipValue', tipValue);
  },
};

const mutations = {
  addTipValue(state, tipValue) {
    Vue.set(state.tipData, 'total', state.tipData.total + tipValue);
  },

  saveAmazonUrl(state, amazonUrl) {
    Vue.set(state, 'amazonUrl', amazonUrl);
  },

  saveBookshelf(state, bookshelf) {
    if (state.bookshelf === bookshelf) {
      return;
    }

    Vue.set(state, 'bookshelf', bookshelf);
  },

  saveIsLoadingTipData(state) {
    Vue.set(state.tipData, 'isLoading', true);
  },

  saveTipValue(state, tipValue) {
    Vue.set(state.tipData, 'total', tipValue);
  },

  saveVoteData(state, voteData) {
    if (!this.state.voteData) {
      Vue.set(state, 'voteData', voteData);
      return;
    }

    Object.keys(obj).forEach((key) => {
      Vue.set(state.voteData, key, voteData[key]);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
